/* ============================================================
   MELT CLUB — theme.js  (Shopify OS 2.0 port of the v6 prototype)
   Vanilla JS, no dependencies.
   Cart state lives in Shopify: mutations go through /cart/add.js
   and /cart/change.js with sections: "cart-drawer" bundled in the
   POST body; the returned section HTML is parsed and swapped into
   [data-cart-items] / [data-cart-subtotal], and [data-cart-count]
   badges sync from data-item-count. Globals from window.MeltClub
   (layout/theme.liquid).
   ============================================================ */
(function () {
  "use strict";
  var REDUCED = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var NOANIM = location.search.indexOf("noanim") !== -1;
  var MC = window.MeltClub || {};
  var ROUTES = MC.routes || {};
  var CART_SECTION = MC.cartSectionId || "cart-drawer";
  var MONEY_FORMAT = MC.moneyFormat || "${{amount}}";

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === "string") cents = cents.replace(".", "");
    var formatString = format || MONEY_FORMAT;
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ",";
      decimal = decimal || ".";
      if (isNaN(number) || number == null) return 0;
      number = (number / 100).toFixed(precision);
      var parts = number.split(".");
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : "";
      return dollars + centsPart;
    }
    var value = "";
    var match = formatString.match(placeholderRegex);
    switch (match ? match[1] : "amount") {
      case "amount": value = formatWithDelimiters(cents, 2); break;
      case "amount_no_decimals": value = formatWithDelimiters(cents, 0); break;
      case "amount_with_comma_separator": value = formatWithDelimiters(cents, 2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator": value = formatWithDelimiters(cents, 0, "."); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }
  /* drawer/tiles show "$12", not "$12.00" — mirror Liquid money_without_trailing_zeros */
  function money(cents) {
    return formatMoney(cents, MONEY_FORMAT).replace(/([.,]00)(?=\s|$|<)/, "");
  }

  /* ---------- marquees ---------- */
  $$("[data-marquee]").forEach(function (track) {
    var copy = track.innerHTML;
    track.innerHTML = '<div class="mq-copy">' + copy + '</div><div class="mq-copy" aria-hidden="true">' + copy + "</div>";
  });

  /* ---------- header: mega menu ---------- */
  $$("[data-mega-btn]").forEach(function (btn) {
    var mega = document.getElementById(btn.getAttribute("data-mega-btn"));
    if (!mega) return;
    btn.addEventListener("click", function (e) {
      e.stopPropagation();
      var open = mega.classList.toggle("open");
      btn.setAttribute("aria-expanded", String(open));
    });
    document.addEventListener("click", function (e) {
      if (!mega.contains(e.target) && e.target !== btn) {
        mega.classList.remove("open");
        btn.setAttribute("aria-expanded", "false");
      }
    });
  });

  /* ---------- header: search overlay + predictive results ---------- */
  var searchBtn = $("[data-search-btn]"), searchBar = $("[data-search-bar]");
  var predictive = searchBar ? $("[data-predictive-results]", searchBar) : null;
  function closePredictive() {
    if (predictive) { predictive.hidden = true; predictive.innerHTML = ""; }
  }
  if (searchBtn && searchBar) {
    searchBtn.addEventListener("click", function () {
      searchBar.classList.add("open");
      var inp = $("input[type=search]", searchBar); if (inp) inp.focus();
    });
    var closeS = $("[data-search-close]", searchBar);
    if (closeS) closeS.addEventListener("click", function () {
      searchBar.classList.remove("open");
      closePredictive();
    });
  }
  if (searchBar && predictive) {
    var sInput = $("input[type=search]", searchBar);
    var sTimer = null;
    if (sInput) sInput.addEventListener("input", function () {
      clearTimeout(sTimer);
      var q = sInput.value.trim();
      if (q.length < 2) { closePredictive(); return; }
      sTimer = setTimeout(function () {
        fetch("/search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=hide")
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (sInput.value.trim() !== q) return; // stale response
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) {
              predictive.innerHTML = '<p class="pr-empty">No matches. Try &ldquo;pistachio&rdquo; or &ldquo;caramel&rdquo;.</p>';
            } else {
              predictive.innerHTML = products.map(function (p) {
                var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
                var safeTitle = document.createElement("i");
                safeTitle.textContent = p.title;
                return '<a class="pr-item" href="' + p.url + '">' +
                  (img ? '<img src="' + img + '" alt="" loading="lazy" width="56" height="56">' : "") +
                  '<span class="pr-t">' + safeTitle.innerHTML + "</span>" +
                  '<span class="pr-p">' + money(Math.round(parseFloat(p.price) * 100)) + "</span></a>";
              }).join("");
            }
            predictive.hidden = false;
          })
          .catch(function () { closePredictive(); });
      }, 250);
    });
  }

  /* ---------- layers ---------- */
  var mnav = $("[data-mnav]"), menuBtn = $("[data-menu-btn]");
  var drawer = $("[data-cart-drawer]");
  var qv = $("[data-qv]");
  function backdrop() { return $("[data-backdrop]"); }
  function lockScroll(on) { document.body.style.overflow = on ? "hidden" : ""; }

  function closeLayer(el) { if (el) el.classList.remove("open"); }
  function anyOpen() { return [qv, drawer, mnav].some(function (el) { return el && el.classList.contains("open"); }); }
  function syncChrome() {
    var open = anyOpen();
    if (backdrop()) backdrop().classList.toggle("open", open);
    lockScroll(open);
  }
  function closeLayers() {
    [qv, drawer, mnav].forEach(closeLayer);
    syncChrome();
  }
  /* Escape closes only the topmost layer */
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    if (searchBar && searchBar.classList.contains("open")) { searchBar.classList.remove("open"); closePredictive(); return; }
    if (qv && qv.classList.contains("open")) { closeLayer(qv); syncChrome(); return; }
    if (drawer && drawer.classList.contains("open")) { closeLayer(drawer); syncChrome(); return; }
    if (mnav && mnav.classList.contains("open")) { closeLayer(mnav); syncChrome(); return; }
  });
  if (menuBtn && mnav) {
    menuBtn.addEventListener("click", function () { mnav.classList.add("open"); syncChrome(); });
    var mx = $("[data-mnav-close]", mnav);
    if (mx) mx.addEventListener("click", closeLayers);
  }
  if (backdrop()) backdrop().addEventListener("click", closeLayers);

  /* ---------- cart (Shopify AJAX + section re-render) ---------- */
  function cartItemsEl() { return drawer ? $("[data-cart-items]", drawer) : null; }
  function itemCount() {
    var el = cartItemsEl();
    return el ? parseInt(el.getAttribute("data-item-count") || "0", 10) : 0;
  }
  function syncCount() {
    var n = itemCount();
    $$("[data-cart-count]").forEach(function (el) {
      el.textContent = n;
      el.classList.toggle("on", n > 0);
    });
    if (drawer) {
      var co = $("[data-checkout]", drawer);
      if (co && co.closest(".btnw")) co.closest(".btnw").classList.toggle("is-disabled", !n);
    }
  }
  function applyCartSection(html) {
    if (!drawer || html == null) return;
    var doc = new DOMParser().parseFromString(html, "text/html");
    var newItems = doc.querySelector("[data-cart-items]");
    var newSub = doc.querySelector("[data-cart-subtotal]");
    var list = cartItemsEl();
    var sub = $("[data-cart-subtotal]", drawer);
    if (newItems && list) {
      list.innerHTML = newItems.innerHTML;
      list.setAttribute("data-item-count", newItems.getAttribute("data-item-count") || "0");
      list.setAttribute("data-bars", newItems.getAttribute("data-bars") || "0");
    }
    if (newSub && sub) sub.textContent = newSub.textContent;
    syncCount();
  }
  function cartRequest(url, body) {
    body.sections = CART_SECTION;
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function refreshCart() {
    return fetch((ROUTES.root_url || "/") + "?sections=" + CART_SECTION)
      .then(function (r) { return r.json(); })
      .then(function (data) { applyCartSection(data[CART_SECTION]); syncCount(); })
      .catch(function () {});
  }
  function cartAdd(variantId, qty, opts) {
    opts = opts || {};
    /* placeholder variants (empty-store PDP fallback) carry id:null — never POST those */
    if (variantId == null || variantId === "" || isNaN(+variantId)) return Promise.resolve();
    return cartRequest(ROUTES.cart_add_url || "/cart/add.js", { items: [{ id: +variantId, quantity: qty || 1 }] })
      .then(function (data) {
        if (data.status && data.status !== 200) {
          announce(data.description || data.message || "Could not add to bag.");
          return refreshCart();
        }
        if (data.sections) applyCartSection(data.sections[CART_SECTION]);
        if (opts.checkout) { window.location = "/checkout"; return; }
        openCart();
        var sub = drawer ? $("[data-cart-subtotal]", drawer) : null;
        announce("Added to bag." + (sub ? " New subtotal: " + sub.textContent : ""));
      })
      .catch(function () { announce("Could not add to bag. Please try again."); });
  }
  function cartChange(key, qty) {
    return cartRequest(ROUTES.cart_change_url || "/cart/change.js", { id: key, quantity: qty })
      .then(function (data) {
        if (data.status && data.status !== 200) {
          announce(data.description || data.message || "Could not update your bag.");
          return refreshCart();
        }
        if (data.sections) applyCartSection(data.sections[CART_SECTION]);
      })
      .catch(function () { announce("Could not update your bag. Please try again."); });
  }
  /* singles → box upgrade: swap the first eligible Single line for its Box
     variant. Works from the drawer ([data-cart-items]) and the cart page
     (.cart-lines in main-cart). The Box is added FIRST; only once that
     succeeds is the Single line zeroed. The FINAL response's section HTML is
     applied (drawer), or the server-rendered page is reloaded (cart page). */
  function upgradeToPack(trigger) {
    var container = trigger ? trigger.closest("[data-cart-items], .cart-lines") : null;
    if (!container && drawer) container = $("[data-cart-items]", drawer);
    if (!container) return;
    var line = container.querySelector(".cd-line[data-pack-variant-id]");
    if (!line) return;
    var key = line.getAttribute("data-key");
    var packId = line.getAttribute("data-pack-variant-id");
    var out = line.querySelector(".stepper output");
    var qty = out ? parseInt(out.textContent, 10) || 1 : 1;
    var fromPage = !(drawer && drawer.contains(container));
    cartRequest(ROUTES.cart_add_url || "/cart/add.js", { items: [{ id: +packId, quantity: qty }] })
      .then(function (added) {
        if (added && added.status && added.status !== 200) {
          /* add failed — cart untouched, keep the Single */
          announce(added.description || added.message || "Could not upgrade your bag.");
          return;
        }
        return cartRequest(ROUTES.cart_change_url || "/cart/change.js", { id: key, quantity: 0 })
          .then(function (changed) {
            var changeFailed = changed && changed.status && changed.status !== 200;
            if (fromPage) { location.reload(); return; }
            if (changed && changed.sections) applyCartSection(changed.sections[CART_SECTION]);
            else refreshCart();
            if (changeFailed) announce(changed.description || changed.message || "Could not update your bag.");
            else announce("Upgraded to a Box of 4 — free shipping unlocked.");
          });
      })
      .catch(function () {
        announce("Could not upgrade your bag. Please try again.");
        refreshCart();
      });
  }

  function openCart() {
    if (!drawer) return;
    closeLayer(qv);
    drawer.classList.add("open");
    syncChrome();
    var x = $("[data-cart-close]", drawer); if (x) x.focus();
  }
  if (drawer) {
    /* delegated: survives [data-cart-items] innerHTML swaps */
    drawer.addEventListener("click", function (e) {
      var close = e.target.closest("[data-cart-close]");
      var step = e.target.closest("[data-step]");
      var rm = e.target.closest("[data-rm]");
      var co = e.target.closest("[data-checkout]");
      if (close) { closeLayers(); return; }
      if (step) {
        var key = step.getAttribute("data-key");
        var dir = +step.getAttribute("data-step");
        var out = step.parentNode.querySelector("output");
        var q = (out ? parseInt(out.textContent, 10) : 1) + dir;
        cartChange(key, Math.max(0, q)).then(function () {
          var again = drawer.querySelector('[data-step="' + dir + '"][data-key="' + key + '"]');
          if (again) again.focus();
        });
        return;
      }
      if (rm) { cartChange(rm.getAttribute("data-rm"), 0); return; }
      if (co && itemCount() > 0) window.location = "/checkout";
    });
  }
  $$("[data-cart-open]").forEach(function (b) { b.addEventListener("click", openCart); });

  /* upsell Upgrade — delegated on document: the button lives in the drawer
     AND in the server-rendered cart page (main-cart) */
  document.addEventListener("click", function (e) {
    var up = e.target.closest("[data-upsell]");
    if (up) upgradeToPack(up);
  });

  /* cross-tab / bfcache sync: re-fetch the drawer section when the page resurfaces */
  window.addEventListener("pageshow", function (e) { if (e.persisted) refreshCart(); });
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "visible") refreshCart();
  });

  /* quick add buttons (tiles, merch, bundles) — value/attr carries the variant
     id. Delegated on document (bound once here) so tiles swapped in later by
     the recommendations fetch keep working; disabled buttons never emit click. */
  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-quick-add]");
    if (!b || b.disabled) return;
    e.preventDefault();
    var id = b.getAttribute("data-variant-id") || b.getAttribute("data-quick-add");
    if (!id || isNaN(+id)) return;
    cartAdd(+id, 1);
  });

  /* ---------- account addresses: country selects ----------
     main-addresses renders <select data-default="{{ form.country }}"> filled by
     all_country_option_tags; apply the saved value (match by option value or
     text). Idempotent: re-running lands on the same option. */
  $$("select[data-default]").forEach(function (sel) {
    var def = sel.getAttribute("data-default");
    if (!def) return;
    for (var i = 0; i < sel.options.length; i++) {
      var o = sel.options[i];
      if (o.value === def || (o.textContent || "").trim() === def) {
        if (sel.selectedIndex !== i) sel.selectedIndex = i;
        break;
      }
    }
  });

  /* toast (role=status announces once) */
  function announce(msg) {
    var t = $("[data-toast]");
    if (t) {
      t.textContent = msg; t.classList.add("on");
      clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove("on"); }, 2600);
    }
  }

  /* ---------- quick view ---------- */
  /* tile buttons carry {handle, url}; the product .js endpoint supplies real variants */
  var qvState = { product: null, qty: 1, url: "" };
  function qvVariants() { return (qvState.product && qvState.product.variants) || []; }
  function qvVariant() {
    var v = $("input[name=qvvariant]:checked", qv);
    var variants = qvVariants();
    var idx = v && v.value === "pack" ? 1 : 0;
    return variants[Math.min(idx, variants.length - 1)];
  }
  function qvSync() {
    var cv = qvVariant();
    if (!cv) return;
    $("[data-qv-qty]", qv).textContent = qvState.qty;
    $("[data-qv-price]", qv).textContent = money(cv.price);
    $("[data-qv-total]", qv).textContent = "– " + money(cv.price * qvState.qty);
  }
  function openQv(payload) {
    var url = (payload.url || "").split("?")[0];
    fetch(url + ".js")
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (product) {
        qvState = { product: product, qty: 1, url: payload.url };
        var img = $("[data-qv-img]", qv);
        if (img) { img.src = product.featured_image || ""; img.alt = product.title; }
        $("[data-qv-title]", qv).textContent = product.title;
        $("[data-qv-desc]", qv).innerHTML = product.description || "";
        $("[data-qv-url]", qv).href = payload.url;
        var pills = $$(".vpill", qv);
        pills.forEach(function (pill, i) {
          var variant = product.variants[i];
          var span = $("span", pill);
          if (!variant) { pill.hidden = true; return; }
          pill.hidden = false;
          var label = variant.title + " — " + money(variant.price);
          if (i > 0 && variant.title.indexOf("Box") !== -1 && product.variants[0]) {
            var save = product.variants[0].price * 4 - variant.price;
            if (save > 0) label += ' <em class="save-chip">Save ' + money(save) + "</em>";
          }
          if (span) span.innerHTML = label;
        });
        var first = $("input[name=qvvariant][value=single]", qv);
        if (first) first.checked = true;
        qvSync();
        qv.classList.add("open"); syncChrome();
        $("[data-qv-close]", qv).focus();
      })
      .catch(function () { announce("Could not load that bar. Please try again."); });
  }
  if (qv) {
    /* delegated on document (bound once, inside this if-guard) so tiles
       swapped in by the recommendations fetch keep working */
    document.addEventListener("click", function (e) {
      var b = e.target.closest("[data-qv-open]");
      if (!b || b.disabled) return;
      e.preventDefault();
      openQv(JSON.parse(b.getAttribute("data-qv-open")));
    });
    $("[data-qv-close]", qv).addEventListener("click", closeLayers);
    $$("[data-qv-step]", qv).forEach(function (b) {
      b.addEventListener("click", function () {
        qvState.qty = Math.max(1, qvState.qty + (+b.getAttribute("data-qv-step")));
        qvSync();
      });
    });
    $$("input[name=qvvariant]", qv).forEach(function (r) { r.addEventListener("change", qvSync); });
    var qvAddBtn = $("[data-qv-add]", qv);
    if (qvAddBtn) qvAddBtn.addEventListener("click", function () {
      var cv = qvVariant();
      if (cv) cartAdd(cv.id, qvState.qty);
    });
    var qvBuy = $("[data-qv-buy]", qv);
    if (qvBuy) qvBuy.addEventListener("click", function () {
      var cv = qvVariant();
      if (cv) cartAdd(cv.id, qvState.qty, { checkout: true });
    });
  }

  /* ---------- focus carousel ---------- */
  $$("[data-fcar]").forEach(function (root) {
    var track = $(".fcar-track", root);
    var items = $$(".fcar-item", root);
    if (!track || !items.length) return;
    var sect = root.closest("section") || document;
    var cap = $(".fcar-caption", sect);
    var nextB = $("[data-fcar-next]", sect), prevB = $("[data-fcar-prev]", sect);
    var INSTANT = NOANIM || REDUCED;
    var idx = Math.min(1, items.length - 1);
    var capIdx = null;
    /* drag state (declared before apply(); its rAF callback reads startX) */
    var startX = null, moved = false, dragId = null, baseT = 0, curT = 0;
    var samples = [];

    /* translateX that centers item i in the carousel viewport */
    function posFor(i) {
      var el = items[i];
      return root.clientWidth / 2 - (el.offsetLeft + el.offsetWidth / 2);
    }
    /* continuous item index for a track translate, clamped to the ends */
    function fracFor(t) {
      var n = items.length;
      if (t >= posFor(0)) return 0;
      if (t <= posFor(n - 1)) return n - 1;
      for (var i = 0; i < n - 1; i++) {
        var a = posFor(i), b = posFor(i + 1);
        if (t <= a && t >= b) return i + (a - t) / (a - b);
      }
      return n - 1;
    }
    /* rendered translateX right now — lets a grab freeze a running snap */
    function currentT() {
      var cs = getComputedStyle(track).transform;
      if (!cs || cs === "none") return 0;
      var m = cs.match(/matrix(?:3d)?\(([^)]+)\)/);
      if (!m) return 0;
      var p = m[1].split(",");
      return parseFloat(p.length > 6 ? p[12] : p[4]) || 0;
    }

    function apply(animate, quick) {
      items.forEach(function (el, i) { el.classList.toggle("active", i === idx); });
      if (!animate) track.style.transition = "none";
      else track.style.transition = quick ? "transform .32s cubic-bezier(.22,.61,.36,1)" : "";
      track.style.transform = "translateX(" + posFor(idx) + "px)";
      if (!animate) requestAnimationFrame(function () { if (startX === null) track.style.transition = ""; });
      if (cap && capIdx !== idx) {
        capIdx = idx;
        var swap = function () {
          $$("[data-cap]", cap).forEach(function (c) {
            c.hidden = c.getAttribute("data-cap") !== String(idx);
          });
          cap.classList.remove("fade");
        };
        if (!animate || INSTANT) { swap(); }
        else { cap.classList.add("fade"); setTimeout(swap, 220); }
      }
    }
    if (nextB) nextB.addEventListener("click", function () { idx = (idx + 1) % items.length; apply(!INSTANT); });
    if (prevB) prevB.addEventListener("click", function () { idx = (idx - 1 + items.length) % items.length; apply(!INSTANT); });
    items.forEach(function (el, i) {
      el.addEventListener("click", function (e) {
        /* real product behind the block → the tile is a link, focused or not
           (post-drag clicks never get here — the capture guard below eats them) */
        var url = el.getAttribute("data-url");
        if (url) {
          if (e.metaKey || e.ctrlKey || e.shiftKey) window.open(url, "_blank");
          else window.location.href = url;
          return;
        }
        if (i !== idx) { idx = i; apply(!INSTANT); }
      });
    });
    window.addEventListener("resize", function () { if (startX === null) apply(false); });
    apply(false);

    /* -- realtime drag: track follows the pointer 1:1; release snaps to the
          nearest item, a flick advances past it in the flick direction -- */
    root.addEventListener("pointerdown", function (e) {
      if (startX !== null) return;                 /* ignore a second finger */
      if (e.button != null && e.button !== 0) return;
      dragId = e.pointerId;
      startX = e.clientX; moved = false;
      baseT = curT = currentT();                   /* grab mid-animation right where it is */
      track.style.transition = "none";
      track.style.transform = "translateX(" + baseT + "px)";
      samples = [{ t: e.timeStamp, x: e.clientX }];
      root.classList.add("dragging");
      try { root.setPointerCapture(e.pointerId); } catch (err) {}
    });
    root.addEventListener("pointermove", function (e) {
      if (startX === null || e.pointerId !== dragId) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 8) moved = true;
      var raw = baseT + dx;
      var tMax = posFor(0), tMin = posFor(items.length - 1);
      if (raw > tMax) raw = tMax + (raw - tMax) * 0.35;      /* rubber-band past the ends */
      else if (raw < tMin) raw = tMin + (raw - tMin) * 0.35;
      curT = raw;
      track.style.transform = "translateX(" + curT + "px)";
      samples.push({ t: e.timeStamp, x: e.clientX });
      while (samples.length > 1 && e.timeStamp - samples[0].t > 120) samples.shift();
    });
    /* pointer px/ms over roughly the last 80ms (track follows 1:1, same sign) */
    function releaseVelocity(endT, endX) {
      var i = samples.length - 1;
      while (i > 0 && endT - samples[i - 1].t <= 80) i--;
      var dt = endT - samples[i].t;
      return dt > 0 ? (endX - samples[i].x) / dt : 0;
    }
    function settle(v) {
      var f = fracFor(curT), target;
      if (v <= -0.4) target = Math.ceil(f);        /* flick left → next, even if not nearest */
      else if (v >= 0.4) target = Math.floor(f);   /* flick right → prev */
      else target = Math.round(f);                 /* slow release → nearest to center */
      idx = Math.max(0, Math.min(items.length - 1, target));
      startX = null; dragId = null;
      root.classList.remove("dragging");
      apply(!INSTANT, true);
    }
    root.addEventListener("pointerup", function (e) {
      if (startX === null || e.pointerId !== dragId) return;
      settle(moved ? releaseVelocity(e.timeStamp, e.clientX) : 0);
    });
    root.addEventListener("pointercancel", function (e) {
      if (startX === null || e.pointerId !== dragId) return;
      settle(0);                                   /* browser claimed the gesture (pan-y scroll) */
    });
    root.addEventListener("click", function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
  });

  /* ---------- PDP ---------- */
  var gallery = $("[data-gallery]");
  if (gallery) {
    $$("[data-thumb]").forEach(function (t) {
      t.addEventListener("click", function () {
        var id = t.getAttribute("data-thumb");
        $$(".gmedia", gallery).forEach(function (m) { m.classList.toggle("on", m.getAttribute("data-media") === id); });
        $$("[data-thumb]").forEach(function (x) { x.setAttribute("aria-current", x === t ? "true" : "false"); });
      });
    });
  }

  var pdp = $("[data-pdp]");
  if (pdp) {
    /* data-product: {handle, title, variants: [{id, title, price(cents), bars}, ...]} */
    var P = JSON.parse(pdp.getAttribute("data-product"));
    /* empty-store placeholder emits the prototype shape {price, packPrice} in
       dollars with no variants — synthesize them so the pills sync prices */
    var variants = P.variants || [
      { id: null, title: "Single", price: Math.round((P.price || 0) * 100) },
      { id: null, title: "Box of 4", price: Math.round((P.packPrice || 0) * 100) }
    ];
    var priceEl = $("[data-price]", pdp);
    var atcPrice = $$("[data-atc-price]");
    /* the real product form renders radios as name="id" (values are variant
       ids); the no-product fallback renders name="variant" (single/pack) —
       every selector site must handle both */
    function variantInputs() {
      return $$('input[type=radio][name="id"], input[name="variant"]', pdp);
    }
    function currentVariant() {
      var v = variantInputs().filter(function (x) { return x.checked; })[0];
      if (!v || !variants.length) return variants[0];
      var byId = variants.filter(function (x) { return String(x.id) === v.value; })[0];
      if (byId) return byId;
      return v.value === "pack" ? (variants[1] || variants[0]) : variants[0];
    }
    function syncBuy(updateUrl) {
      var cv = currentVariant();
      if (!cv) return;
      if (priceEl) priceEl.textContent = money(cv.price);
      atcPrice.forEach(function (el) { el.textContent = "– " + money(cv.price); });
      var st = $("[data-sticky-variant]"); if (st) st.textContent = cv.title + " · " + money(cv.price);
      if (updateUrl && cv.id != null && history.replaceState) {
        var u = new URL(location.href);
        u.searchParams.set("variant", cv.id);
        history.replaceState(null, "", u);
      }
    }
    /* preselect variant from a shared URL (?variant=<id>) */
    var pv = new URLSearchParams(location.search).get("variant");
    if (pv) {
      var match = variantInputs().filter(function (x) { return x.value === pv; })[0];
      if (!match && variants[1] && String(variants[1].id) === pv) {
        match = $("input[name=variant][value=pack]", pdp);
      }
      if (match) match.checked = true;
    }
    variantInputs().forEach(function (r) {
      r.addEventListener("change", function () { syncBuy(true); });
    });
    $$("[data-atc]").forEach(function (b) {
      b.addEventListener("click", function () {
        var cv = currentVariant();
        if (cv) cartAdd(cv.id, 1);
      });
    });
    var buyNow = $("[data-buy-now]");
    if (buyNow) buyNow.addEventListener("click", function () {
      var cv = currentVariant();
      if (cv) cartAdd(cv.id, 1, { checkout: true });
    });
    syncBuy(false);

    var fbtn = $("[data-flavor-btn]"), flist = $("[data-flavor-list]");
    if (fbtn && flist) {
      fbtn.addEventListener("click", function (e) {
        e.stopPropagation();
        var open = flist.classList.toggle("open");
        fbtn.setAttribute("aria-expanded", String(open));
      });
      document.addEventListener("click", function (e) {
        if (!flist.contains(e.target)) { flist.classList.remove("open"); fbtn.setAttribute("aria-expanded", "false"); }
      });
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && flist.classList.contains("open")) {
          flist.classList.remove("open"); fbtn.setAttribute("aria-expanded", "false");
        }
      });
    }

    $$(".acc", pdp).forEach(function (d) {
      d.addEventListener("toggle", function () {
        if (d.open) $$(".acc", pdp).forEach(function (o) { if (o !== d) o.open = false; });
      });
    });

    var bar = $("[data-sticky-atc]");
    var buyBlock = $("[data-buy-block]", pdp);
    if (bar && buyBlock && "IntersectionObserver" in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          bar.classList.toggle("show", !en.isIntersecting && en.boundingClientRect.top < 0);
        });
      }, { threshold: 0 }).observe(buyBlock);
    }
  }

  /* ---------- reveal ---------- */
  var revealIo = null;
  if ("IntersectionObserver" in window && !REDUCED && !NOANIM) {
    revealIo = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("in"); revealIo.unobserve(en.target); } });
    }, { threshold: 0.1 });
  }
  function reveal(root) {
    $$(".rv:not(.in)", root).forEach(function (e) {
      if (revealIo) revealIo.observe(e); else e.classList.add("in");
    });
  }
  reveal(document);

  /* Nodes swapped in later (recommendations fetch, theme editor section
     re-render) arrive unobserved — re-scan on the bubbled load event. */
  document.addEventListener("shopify:section:load", function (e) {
    reveal(e.target && e.target.closest ? e.target.closest("section, .shopify-section") || document : document);
  });

  syncCount();
})();
